import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  font-family: Cabin-Bold, sans-serif;
  display: none;
  align-items: center;
  flex-direction: column;
  position: relative;
  width: 200px;
  
  @media (min-width: 768px) {
    display: flex;
  }
 `;

const Bubble = styled.div`
  background: #004a87;
  color: #fff;
  border-radius: 50%;
	width: 50px;
	height: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1;
	font-family: Cabin-Bold, sans-serif;
	font-size: 14px;
	
	@media(min-width: 1200px) {
		width: 70px;
	  height: 70px;
	  font-size: 16px;
	}
	
	@media(min-width: 1680px) {
		width: 80px;
	  height: 80px;
	  font-size: 22px;
	}
`;

const Text = styled.div`
  text-align: center;
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  background: #fff;
  font-family: Cabin-Bold, sans-serif;
  white-space: pre-line;
  display: flex;
  flex-direction: column;
  
  ${props => props.top ?
  'top: 0;' : 'bottom: 0;'
  };
  
  @media (min-width: 992px) {
    font-size: 14px;
  }
  
  @media (min-width: 1680px) {
    font-size: 17px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  background: #fff;
  width: 100%;
  ${props => props.top ?
  'bottom: 0; top: -125px;' : 'bottom: -125px; top: 0;'
  }
  
  :before {
    content: "";
    background: #dedede;
    width: 2px;
    top: 0;
    bottom: 0;
    position: absolute;
  }
`;

const TimeBubble = (props) => {
    const {date, text, top} = props;
    return (
      <Container top={top}>
          {top ?
            <TextContainer top={top}>
                <Text
                  top={top}
                  dangerouslySetInnerHTML={{__html: text}}
                />
            </TextContainer> :
            <Bubble>{date}</Bubble>
          }
          {top ?
            <Bubble>{date}</Bubble> :
            <TextContainer>
                <Text
                  top={top}
                  dangerouslySetInnerHTML={{__html: text}}
                />
            </TextContainer>
          }
      </Container>
    );
};

export default TimeBubble;



// WEBPACK FOOTER //
// ./src/components/GetToKnow/TimeBubble.js